const basicPreferences = [
    {
        key: "noise",
        name: "What is your ideal noise level?",
        values: ["Quiet", "Some Noise", "Loud"],
    },
    {
        key: "cleanliness",
        name: "How clean do you like to keep your room?",
        values: ["Messy", "Somewhat Organized", "Organized", "Spotless"],
    },
    {
        key: "closeness",
        name: "How close would you like to be with your roommate?",
        values: ["Not Close", "Acquaintances", "Friendly", "Good Friends"],
    },
    {
        key: "academics",
        name: "How important are academics to you?",
        values: ["Not Important", "Somewhat Important", "Important", "Very Important"],
    },
    {
        key: "inRoom",
        name: "How frequently will you be in your room?",
        values: ["Rarely", "Somewhat Frequently", "Frequently", "All the Time"],
    },
    {
        key: "earlyBird",
        name: "When will you be most active in your room?",
        values: ["Morning", "Afternoon", "Evening", "Late Night"],
    },
    {
        key: "guests",
        name: "How often will you have guests over?",
        values: ["Never", "Once in a While", "Only on Weekends", "All the Time"],
    },
]

export default basicPreferences